import React from 'react';
import { getLocales } from '@src/global-locales/get-page-locales-data';
const styles = require('./index.less');

export default function EmptyDataTip() {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyInner}>
        <div className={styles.frame} />
        <div className={styles.iconTip} />
        {getLocales('global.comming_soon')}
      </div>
      <div className={styles.emptyShadow}>
        <div className={styles.frame} />
        <div className={styles.iconTip} />
        {getLocales('global.comming_soon')}
      </div>
    </div>
  );
}
